import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import moment from 'moment';
import './MyBookings.css'; // A new CSS file for styling

const MyHotelBookings = () => {
    const { user } = useAuth();
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
   const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    

    useEffect(() => {
        const getBookings = async () => {
            if (!user?.id) {
                setLoading(false);
                setError("User not found. Please log in again.");
                return;
            }

            try {
                const response = await apiService.post(`${config.GETUSERHOTELBOOKINGS}/${user?.id}`, pageSize, pageNumber);
                setBookings(response.data); 
            } catch (err) {
                setError("Could not fetch your hotel bookings. Please try again later.");
                
            } finally {
                setLoading(false);
            }
        };

        getBookings();
    }, [user]); 

    const renderStatusBadge = (status) => {
        let badgeClass = 'bg-secondary';
        switch (status?.toUpperCase()) {
            case 'CONFIRMED':
            case 'SUCCESS':
                badgeClass = 'bg-success';
                break;
            case 'PENDING':
            case 'HOLD':
                badgeClass = 'bg-warning text-dark';
                break;
            case 'CANCELLED':
            case 'FAILED':
                badgeClass = 'bg-danger';
                break;
            default:
                break;
        }
        return <span className={`badge ${badgeClass}`}>{status}</span>;
    };

    return (
        <div className="main-content">
            <div className="profile-page-wrapper">
                <div className="container">
                    {/* <h2 className="profile-title text-center">My Hotel Bookings</h2> */}
                    <div className="bookings-card">
                        {loading ? (
                            <div className="text-center p-2">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2">Loading your bookings...</p>
                            </div>
                        ) : error ? (
                            <div className="alert alert-danger">{error}</div>
                        ) : bookings.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                    <thead className="table-light">
                                        <tr>
                                                    <th>Booking No</th>
                                                    <th>Destination</th>
                                                    <th>CheckIn-CheckOut</th>
                                                    <th>Traveller</th>
                                                    <th>Booking</th>
                                                    <th>Payment</th>
                                                    <th>Amount</th>
                                                    <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bookings.map((booking) => (
                                            <tr key={booking.hotelBookingId}>
                                                <td>
                                                    <strong>{booking.bookingNo}</strong><br />
                                                </td>
                                                <td>{booking.city}</td>
                                                <td>{moment(booking.checkIn).format("DD MMM YYYY, h:mm A")} - {moment(booking.checkOut).format("DD MMM YYYY, h:mm A")}</td>
                                                <td>{booking.travellerName}</td>
                                                <td>{renderStatusBadge(booking.bookingStatus)}</td>
                                                <td>{renderStatusBadge(booking.paymentStatus)}</td>
                                                <td><strong>{booking.totalPrice} {booking.currency}</strong></td>
                                                <td>
                                                    <Link to={`/my-hotel/booking/${booking.hotelBookingId}`} className='btn btn-sm btn-outline-primary'>
                                                        View Details
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center p-5">
                                <p className="mb-0">You have no flight bookings yet.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyHotelBookings;